import { Component, Input } from '@angular/core';
import { BaseComponent } from '../common/baseComponent/base.component';
import { ERRORTYPE } from './form.objects';

@Component({
  selector: 'formControlErrorMessage',
  templateUrl: 'formControl-errorMessage.template.html'
})
export class FormControlErrorMessageComponent extends BaseComponent {
  @Input()
  public errors: any;

  public ERRORTYPE = ERRORTYPE;

  ngOnDestroy(): void {
    this.errors = null;
    super.ngOnDestroy();
  }
}
